module.exports = __webpack_public_path__ + "static/portfolio-mas-3-682a9e1c5601a0962cc18960bd176b70.jpg";